export enum Partner {
  VIVICITY = "VIVICITY",
  BIKESOUL = "BIKESOUL"
}

export class PartnerData {
  static readonly VIVICITY = new PartnerData(
    Partner.VIVICITY,
    "VIVI City"
  );

  static readonly BIKESOUL = new PartnerData(
    Partner.BIKESOUL,
    "BikeSoul"
  );

  private constructor(
    public readonly key: Partner,
    public readonly label: string,
  ) { }

  static values(): PartnerData[] {
    return [PartnerData.VIVICITY,
    PartnerData.BIKESOUL];
  }

  static get(key: Partner) {
    return PartnerData.values().find((value) => value.key === key);
  }

  toString() {
    return this.key;
  }
}
